import styled from "styled-components";
import { SpacingStyle, getMarginStyle, getPaddingStyle } from "core/styles/paddingMarginStyle";

export const Container = styled.div<SpacingStyle>`
  display: flex;
  align-items: center;

  ${getMarginStyle}
  ${getPaddingStyle}
`;

export const Icon = styled.img<{ disabled?: boolean; margin?: string }>`
  height: ${({ height }) => height || "16px"};
  width: ${({ width }) => width || "16px"};
  margin-right: 8px;
  margin: ${({ margin }) => margin};

  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
`;

export const Label = styled.div`
  font-family: Nunito-Sans;
  font-size: 14px;
  color: ${({ theme }) => theme?.colors?.neutral.neutral90};
`;

export const Input = styled.input`
  display: none;
`;
